import { ITEM_TYPES } from '@wix/advanced-seo-utils';
import { SITE_LEVEL_PAGE_ID } from '../../consts';
const aggregateRulesByPages = function (pages, strategy) {
  if (strategy === void 0) {
    strategy = 'object';
  }
  const rulesAggregation = new Map();
  pages.forEach(pageData => {
    var _pageData$analysisDat;
    const pageId = pageData.pageId;
    const pageRulesStatus = ((_pageData$analysisDat = pageData.analysisData) == null || (_pageData$analysisDat = _pageData$analysisDat.summary) == null ? void 0 : _pageData$analysisDat.rulesStatusMap) || {};
    Object.entries(pageRulesStatus).forEach(_ref => {
      let [ruleId, ruleStatus] = _ref;
      if (!rulesAggregation.has(ruleId)) {
        rulesAggregation.set(ruleId, {
          failedTaskCount: 0,
          payload: strategy === 'array' ? [] : {},
          taskCount: 0,
          taskName: ruleId
        });
      }
      const rule = rulesAggregation.get(ruleId);
      if (strategy === 'array') {
        const payloadArray = rule.payload;
        payloadArray.push(ruleStatus);
        rule.payload = payloadArray;
        rule.taskCount = payloadArray.length;
        rule.failedTaskCount = payloadArray.filter(status => status === 'failed').length;
      } else {
        const payloadObject = rule.payload;
        payloadObject[pageId] = ruleStatus;
        rule.taskCount = Object.keys(payloadObject).length;
        rule.failedTaskCount = Object.values(payloadObject).filter(status => status === 'failed').length;
      }
    });
  });
  return Array.from(rulesAggregation.values());
};

// Function to get scan rules for static pages and site level pages only
export const getScanByRuleStaticAndSiteLevelPages = scanData => {
  const pages = Array.from(scanData.values()).filter(pageData => pageData.itemType === ITEM_TYPES.STATIC_PAGE_V2 || pageData.itemType === 'SITE_LEVEL');
  return aggregateRulesByPages(pages, 'object');
};

// Function to get scan rules for vertical pages grouped by item type
export const getScanByRuleVertical = scanData => {
  // Process vertical page types for rule breakdown analysis
  const verticalPages = Array.from(scanData.values()).filter(groupData => groupData.itemType !== ITEM_TYPES.STATIC_PAGE_V2 && groupData.pageId !== SITE_LEVEL_PAGE_ID && groupData.isTpaPage === false);

  // Group vertical pages by their item type (e.g., STORES_PRODUCT, BLOG_POST)
  const pagesByItemType = verticalPages.reduce((acc, groupData) => {
    const itemType = groupData.itemType;
    if (!acc[itemType]) {
      acc[itemType] = [];
    }
    acc[itemType].push(groupData);
    return acc;
  }, {});

  // Create rule breakdown for each item type group
  const itemTypeRuleBreakdowns = Object.entries(pagesByItemType).map(_ref2 => {
    let [itemType, pages] = _ref2;
    const verticalPagesRuleBreakdown = aggregateRulesByPages(pages, 'array');
    return [itemType, verticalPagesRuleBreakdown];
  });
  return itemTypeRuleBreakdowns;
};
//# sourceMappingURL=get-scan-by-rule.js.map